import { ComponentType } from 'react';
import { createHeroiconRenderer } from '@kevlarcon/pages';

/**
 * Backs `PagesConfig.iconOptions`/`renderIcon` — see
 * `createHeroiconRenderer`'s docstring in `@kevlarcon/pages` for why this
 * glob has to live here, in this app's own source, rather than inside that
 * package: `import.meta.glob` is a Vite compile-time macro, evaluated once
 * by whichever Vite process compiles the file it's written in. This app's
 * own build is what needs to resolve it, against this app's own installed
 * `@heroicons/react` and this app's own content.
 *
 * The `esm/` subdirectory specifically (not the package's default `.js`
 * files, which are plain CommonJS `require()`/`module.exports`) — those load
 * fine in a production Rollup bundle but 500 in the Vite dev server with
 * "require is not defined": nothing pre-transforms them to ESM, because a
 * path reached only through this glob never enters Vite's normal
 * optimizeDeps scan.
 */
const HEROICON_MODULES = import.meta.glob<{ default: ComponentType<{ width?: number; height?: number }> }>(
  '/node_modules/@heroicons/react/24/outline/esm/*.js',
);

export const { listAvailableIcons, renderIcon } = createHeroiconRenderer(HEROICON_MODULES);
